define('application',[
  "angular"
], function() {

  return angular.module("hotspot-app", []);

});
